import { AccessGrant, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { schedulesVar } from 'state/vars';

export const setSchedulesAction = (schedules: VisitorGroup[]) => {
  schedulesVar(schedules);
};

export const updateAccessGrantAction = (updatedSchedule: AccessGrant) => {
  const currentVisitorGroupsWithSchedules = schedulesVar();
  const updatedVisitorGroups = currentVisitorGroupsWithSchedules.map((group) => ({
    ...group,
    accessGrants: group.accessGrants.map((grant) => (grant.id === updatedSchedule.id ? updatedSchedule : grant))
  }));

  schedulesVar(updatedVisitorGroups);
};
